import script from "./matches-ongoing.vue?vue&type=script&setup=true&lang=js"
export * from "./matches-ongoing.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__